import AssetList from './AssetList.container'
export default AssetList
